import * as React from "react";
function AspectSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 3H5C3.9 3 3 4.013 3 5.25v13.5C3 19.988 3.9 21 5 21h14c1.1 0 2-1.012 2-2.25V5.25C21 4.013 20.1 3 19 3zm-1 15.75H6c-.55 0-1-.506-1-1.125V6.375c0-.619.45-1.125 1-1.125h12c.55 0 1 .506 1 1.125v11.25c0 .619-.45 1.125-1 1.125z"
  }));
}
const ForwardRef = React.forwardRef(AspectSquareIcon);
export default ForwardRef;